module.exports = __webpack_public_path__ + "img/Flag_of_the_United_States.aefba3fe.svg";